export default __webpack_public_path__ + "static/1198-7765605c436a1ec17f644770706a16e1.gif";